import { faBuildingShield, faCartArrowDown, faDesktop, faExchangeAlt, faFileInvoice, faListCheck, faReceipt, faRobot, faTags, faTicket, faTruckFast, faUsers, faUsersGear, faUsersRectangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function GreyBoxForReports({ icon, name, onclickfunc }) {
    function getIcons() {
        switch (icon) {
            case 'faTicket':
                return faTicket;
            case 'faDesktop':
                return faDesktop;
            case 'faUsers':
                return faUsers;
            case 'faUsersGear':
                return faUsersGear;
            case 'faTruckFast':
                return faTruckFast;
            case 'faFileInvoice':
                return faFileInvoice;
            case 'faReceipt':
                return faReceipt;
            case 'faUsersRectangle':
                return faUsersRectangle;
            case 'faRobot':
                return faRobot;
            case 'faTags':
                return faTags;
            case 'faListCheck':
                return faListCheck;
            case 'faExchangeAlt':
                return faExchangeAlt;
            case 'faCartArrowDown':
                return faCartArrowDown;
            case 'faBuildingShield':
                return faBuildingShield;
        }
    }

    return (
        <div className='greyBoxShadow text-center py-4 h-100'>
            <FontAwesomeIcon icon={getIcons()} style={{ height: "40px", width: "auto" }} />
            <h6 className='my-2'>{name}</h6>
            <label className='BorderBtn mt-3 me-0' onClick={onclickfunc}>
                <img src='/images/downloadPlan.svg' className='img-fluid pe-2' />  Download
            </label>
        </div>
    )
}
